<template>
  <div class="casezxlbhf">
    <div class="cont1 between">
      <div class="reply">
        <div class="reply_top between">
          <div class="reply_ti">最新一对一咨询回复</div>
          <div class="reply_mo">更多></div>
        </div>
        <div class="reply_list">
          <div class="reply_item" v-for="item in 4" :key="item">
            <div class="ri1 ellipsis">
              被车撞了除了保险赔偿以外还可以向肇事司机要哪些赔偿金额
            </div>
            <div class="ri2 ellipsis">
              <span>答复</span>如果保险赔偿金额足够赔付，无权要求肇事者赔偿
            </div>
            <div class="ri3 flex_start">
              <img src="../../../assets/case/aaaa1_sample.png" alt="" />
              <span>李XX律师回复</span>
              <span>3分钟前</span>
            </div>
          </div>
        </div>
      </div>
      <div class="often">
        <sub-title text="一对一咨询律师活跃榜" />
        <div class="ranklist">
          <div
            v-for="(item, index) in 6"
            :key="index"
            @mouseover="rki_active = index"
          >
            <div
              class="rankitem flex"
              v-if="rki_active == index"
              :class="{ rki_active: rki_active == index }"
            >
              <div class="rki_cover">
                <img src="../../../assets/case/aaaa1_sample.png" />
              </div>
              <div class="rki_info between">
                <div>
                  <div>
                    <span class="rki1name">张三</span>
                    <span class="rkiprof">律师</span>
                  </div>
                  <div class="rki3">本周回复100人</div>
                </div>
                <div class="rki_btn">快速提问</div>
              </div>
            </div>

            <div class="rankitem flex" v-if="rki_active != index">
              <div class="rki_cover">
                <img v-if="index == 0" src="../../../assets/case/sort_1.png" />
                <img
                  v-else-if="index == 1"
                  src="../../../assets/case/sort_2.png"
                />
                <img
                  v-else-if="index == 2"
                  src="../../../assets/case/sort_3.png"
                />
                <div v-else>{{ index + 1 }}</div>
              </div>
              <div class="rki_info between">
                <div>
                  <span class="rki1name">张三</span>
                  <span class="rkiprof">律师</span>
                </div>
                <div class="rki3">本周回复 <span>100</span>人</div>
              </div>
            </div>
          </div>
        </div>

        <sub-title text="热门法律聚焦" />
        <div class="holafoc">
          <el-carousel
            indicator-position="outside"
            arrow="never"
            trigger="click"
            height="200px"
          >
            <el-carousel-item v-for="item in 3" :key="item">
              <div class="holaitem">
                <div class="haitm_i between" v-for="it in 2" :key="'a' + it">
                  <div class="haitm_cove">
                    <img src="../../../assets/laws/jx_sample2.png" alt="" />
                  </div>
                  <div>
                    <div class="haitm_ti">民法典</div>
                    <div class="haitm_des">
                {{`民法典的颁布和施行会影响到我们生活的方方面面。对于普.. ` | toEllipsisFilter(26)}}
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="cont2 between">
      <div class="speconsu">
        <div class="lbhe_ti">按专长找咨询</div>
        <div class="speconsu_list flex_start wrap">
          <div class="item" v-for="item in 17" :key="item">交通事故</div>
        </div>
      </div>
      <div class="cityconsu">
        <div class="lbhe_ti">按城市找咨询</div>
        <div class="cityc_c">
          <div class="between">
            <el-select
              :popper-append-to-body="false"
              v-model="value"
              placeholder="请选择"
              class="sele1"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="value"
              :popper-append-to-body="false"
              placeholder="请选择"
              class="sele1"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="hf1v1zx">合肥一对一咨询>></div>
        </div>
      </div>
    </div>
    <div class="cont3 between">
      <div class="lascon">
        <div class="lbhe_ti">最新一对一咨询</div>
        <div class="lascon_list">
          <div class="lascon_item between" v-for="item in 8" :key="item">
            <div class="bt">
                {{`被车撞了除了保险赔偿以外还可以向肇事司机要哪些赔偿金额 ` | toEllipsisFilter(37)}}
              
            </div>
            <div class="ti">3分钟前</div>
          </div>
        </div>
      </div>
      <div class="hotLK">
        <sub-title text="热门法律知识" />
        <div class="hotLK_list">
          <div
            class="hotLK_item flex_start "
            v-for="(item, index) in 10"
            :key="index"
          >
            <div class="xh xh1" v-if="index == 0">{{ item }}</div>
            <div class="xh xh2" v-else-if="index == 1">{{ item }}</div>
            <div class="xh xh3" v-else-if="index == 2">{{ item }}</div>
            <div class="xh" v-else>{{ item }}</div>
            <div> {{`烟台市异地长期居住人员备案申请有哪些规定` | toEllipsisFilter(21)}} </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";

export default {
  components: {
    subTitle,
  },
  data: () => ({
    rki_active: 0,
    options: [
      { value: "选项1", label: "安徽1" },
      { value: "选项2", label: "安徽2" },
      { value: "选项3", label: "安徽3" },
      { value: "选项4", label: "安徽4" },
      { value: "选项5", label: "安徽5" },
      { value: "选项6", label: "安徽6" },
      { value: "选项7", label: "安徽7" },
      { value: "选项8", label: "安徽8" },
    ],
    value: "",
  }),
};
</script>

<style lang="scss" scope >
.casezxlbhf {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .cont1 {
    align-items: flex-start;
    .reply {
      width: 760px;
      .reply_top {
        .reply_ti {
          font-size: 24px;
          color: #333333;
        }
        .reply_mo {
          font-size: 14px;
          color: #666666;
        }
      }
      .reply_list {
        .reply_item {
          margin-top: 20px;
          width: 100%;
          height: 174px;
          padding: 24px 32px;
          color: #999999;
          background-color: #fafafa;
          .ri1 {
            font-size: 18px;
            color: #333333;
            line-height: 18px;
            cursor: pointer;
          }
          .ri2 {
            cursor: pointer;
            font-size: 16px;
            line-height: 16px;
            margin: 18px 0 20px;
            span {
              padding: 0px 6px;
              margin-right: 16px;
              font-size: 14px;
              color: #fff;
              background-color: #3a78fc;
            }
          }
          .ri3 {
            font-size: 14px;
            img {
              border-radius: 50%;
              width: 48px;
              height: 48px;
            }
            span {
              margin-left: 20px;
            }
          }
        }
      }
    }
    .often {
      width: 410px;
      //   background-color: rgb(238, 184, 184);
      .ranklist {
        width: 100%;
        height: 406px;
        padding: 1px 33px;
        margin: 30px 0;
        background: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .rankitem {
          margin-top: 30px;
          .rki_cover {
            width: 74px;
            text-align: center;
            div {
              width: 26px;
              height: 26px;
              margin: 0 auto;
              line-height: 26px;
              color: #bcbcbc;
              font-size: 14px;
              border-radius: 50%;
              border: 1px solid #bcbcbc;
            }
            img {
              width: 26px;
              height: 26px;
              border-radius: 50%;
            }
          }
          .rki_info {
            flex: 1;
            .rki1name {
              font-size: 18px;
              color: #333333;
              font-weight: bold;
              margin-right: 12px;
            }
            .rkiprof {
              font-size: 16px;
              color: #999999;
            }
            .rki3 {
              font-size: 14px;
              color: #999999;
              span {
                color: #da0000;
              }
            }
          }
        }
        .rki_active {
          .rki_cover img {
            width: 62px;
            height: 62px;
            border-radius: 50%;
          }
          .rki3 {
            margin-top: 6px;
          }
          .rki_btn {
            width: 78px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            font-size: 14px;
            color: #f25618;
            border: 1px solid #f25618;
            border-radius: 14px;
            cursor: pointer;
          }
        }
      }

      .holafoc {
        margin-top: 30px;
        width: 100%;
        padding: 21px 24px;
        background: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);

        .el-carousel__indicator--horizontal {
          padding: 0 4px;
        }

        .is-active {
          .el-carousel__button {
            background-color: #1f7dff;
          }
        }
        .el-carousel__indicators {
          margin-top: 4px;
        }

        .holaitem {
          width: 356px;
          height: 200px;
          margin: 0 auto;
          .haitm_i {
            margin-bottom: 20px;
            cursor: pointer;
            &:hover {
              .haitm_ti {
                color: #0465ea;
              }
            }
            .haitm_cove {
              margin-right: 20px;
              img {
                width: 140px;
                height: 90px;
              }
            }
            .haitm_ti {
              font-size: 18px;
              color: #666666;
              line-height: 28px;
            }
            .haitm_des {
              font-size: 14px;
              color: #999999;
              line-height: 24px;
            }
          }
        }
      }
    }
  }

  .lbhe_ti {
    font-size: 24px;
    color: #333333;
  }

  .cont2 {
    margin-top: 30px;
    align-items: flex-start;
    .speconsu {
      width: 760px;
      font-size: 16px;
      .speconsu_list {
        height: 181px;
        margin-top: 30px;
        padding: 28px 10px 0;
        background: #fafafa;
        .item {
          cursor: pointer;
          width: 102px;
          margin-bottom: 30px;
          text-align: center;
          &:hover {
            color: #0465ea;
          }
        }
      }
    }
    .cityconsu {
      width: 410px;

      .el-select .el-input.is-focus .el-input__inner {
        border-color: #c0c4cc;
      }
      .el-select .el-input__inner:focus {
        border-color: #c0c4cc;
      }
      .el-select-dropdown__wrap {
        max-height: 200px;
      }
      .cityc_c {
        margin-top: 30px;
    padding: 30px 53px;
        width: 410px;
        height: 180px;
        padding-top: 34px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        background-color: #fff;
        .sele1 {
          width: 138px;
          height: 40px;
        }
        .hf1v1zx {
          width: 304px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          margin: 28px auto 0;
          font-size: 20px;
          color: #ffffff;
          background: #f25618;
          cursor: pointer;
          border-radius: 2px;
        }
      }
    }
  }

  .cont3 {
    align-items: flex-start;
    margin-top: 30px;
    .lascon {
      width: 760px;
      .lascon_list {
        background: #fafafa;
        margin-top: 30px;
        padding: 1px 35px;
        height: 430px;
        .lascon_item {
          margin-top: 28px;

          &:hover {
            .bt {
              color: #0465ea;
              &::before {
                background: #0465ea;
              }
            }
          }
          .bt {
            position: relative;
            color: #333;
            cursor: pointer;
            &::before {
              position: absolute;
              top: 50%;
              left: -15px;
              transform: translateY(-50%);
              content: "";
              width: 6px;
              height: 6px;
              background: #aaaaaa;
            }
          }
          .ti {
            font-size: 16px;
            color: #999999;
          }
        }
      }
    }
    .hotLK {
      width: 410px;

      .hotLK_list {
        margin-top: 38px;
        height: 430px;
        padding: 7px 24px;
        background: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .hotLK_item {
          margin-top: 20px;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
          &:hover{
              color: #0465EA;
          }
          .xh {
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: #d8ecff;
            border-radius: 2px;
            font-size: 12px;
            color: #0183ff;
            margin-right: 10px;
          }
          .xh1 {
            background: #ff6600;
            color: #fff;
          }
          .xh2 {
            background: #ff8b3e;
            color: #fff;
          }
          .xh3 {
            background: #f4ab2b;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>